// extracted by mini-css-extract-plugin
module.exports = {"separator":"register_separator__1RgTu","password_generator_icon":"register_password_generator_icon__3ApUa","country_placeholder":"register_country_placeholder__29o_a"};